<!-- Info boxes -->
<div class="row">
    <div class="col-12 col-sm-6 col-md-3">
      <div class="info-box">
        <span class="info-box-icon bg-info elevation-1">
          <i class="fas fa-users"></i>
        </span>
  
        <div class="info-box-content">
          <span class="info-box-text headText">จำนวนพนักงาน</span>
          <span class="info-box-number headText1">
            {{ empData.cntEmp | number }}
            <small></small>
          </span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-12 col-sm-6 col-md-3">
      <div class="info-box mb-3">
        <span class="info-box-icon bg-danger elevation-1"
          ><i class="fas fa-thumbs-up"></i
        ></span>
  
        <div class="info-box-content">
          <span class="info-box-text">Likes</span>
          <span class="info-box-number">41,410</span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
  
    <!-- fix for small devices only -->
    <div class="clearfix hidden-md-up"></div>
  
    <div class="col-12 col-sm-6 col-md-3">
      <div class="info-box mb-3">
        <span class="info-box-icon bg-success elevation-1"
          ><i class="fas fa-shopping-cart"></i
        ></span>
  
        <div class="info-box-content">
          <span class="info-box-text">Sales</span>
          <span class="info-box-number">760</span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-12 col-sm-6 col-md-3">
      <div class="info-box mb-3">
        <span class="info-box-icon bg-warning elevation-1"
          ><i class="fas fa-users"></i
        ></span>
  
        <div class="info-box-content">
          <span class="info-box-text">New Members</span>
          <span class="info-box-number">2,000</span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
  </div>
  
  <div class="row">
    <div class="col-md-6">
      <!-- USERS LIST -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Latest Members</h3>
  
          <div class="card-tools">
            <span class="badge badge-danger">8 New Members</span>
            <button
              type="button"
              class="btn btn-tool"
              data-card-widget="collapse"
            >
              <i class="fas fa-minus"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="remove">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body p-0">
          <ul class="users-list clearfix">
            <li>
              <img src="dist/img/user1-128x128.jpg" alt="User Image" />
              <a class="users-list-name" href="#">Alexander Pierce</a>
              <span class="users-list-date">Today</span>
            </li>
            <li>
              <img src="dist/img/user8-128x128.jpg" alt="User Image" />
              <a class="users-list-name" href="#">Norman</a>
              <span class="users-list-date">Yesterday</span>
            </li>
            <li>
              <img src="dist/img/user7-128x128.jpg" alt="User Image" />
              <a class="users-list-name" href="#">Jane</a>
              <span class="users-list-date">12 Jan</span>
            </li>
            <li>
              <img src="dist/img/user6-128x128.jpg" alt="User Image" />
              <a class="users-list-name" href="#">John</a>
              <span class="users-list-date">12 Jan</span>
            </li>
            <li>
              <img src="dist/img/user2-160x160.jpg" alt="User Image" />
              <a class="users-list-name" href="#">Alexander</a>
              <span class="users-list-date">13 Jan</span>
            </li>
            <li>
              <img src="dist/img/user5-128x128.jpg" alt="User Image" />
              <a class="users-list-name" href="#">Sarah</a>
              <span class="users-list-date">14 Jan</span>
            </li>
            <li>
              <img src="dist/img/user4-128x128.jpg" alt="User Image" />
              <a class="users-list-name" href="#">Nora</a>
              <span class="users-list-date">15 Jan</span>
            </li>
            <li>
              <img src="dist/img/user3-128x128.jpg" alt="User Image" />
              <a class="users-list-name" href="#">Nadia</a>
              <span class="users-list-date">15 Jan</span>
            </li>
          </ul>
          <!-- /.users-list -->
        </div>
        <!-- /.card-body -->
        <div class="card-footer text-center">
          <a href="javascript::">View All Users</a>
        </div>
        <!-- /.card-footer -->
      </div>
      <!--/.card -->
    </div>
  </div>
  
